<script>
import { SearchInput } from '@/components/page/search-input'

export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      types: [
        { label: 'การโอนทั้งหมด', value: null },
        { label: 'โอนทองออก', value: 'transfer' },
        { label: 'รับทองเข้า', value: 'receive' },
        { label: 'เติมทอง', value: 'goldfill' }
      ],
      statuses: [
        { label: 'สถานะทั้งหมด', value: null },
        { label: 'รับแล้ว', value: 'accepted' },
        { label: 'ยกเลิก', value: 'cancelled' }
      ],
      goldTypes: [
        { label: 'ชนิดทองทั้งหมด', value: null },
        { label: 'ทองขาย', value: 'sellgold' },
        { label: 'ทองเก่า', value: 'usedgold' }
      ]
    }
  },

  computed: {
    filteredGoldTypes() {
      const type = this.data.type

      if (type === 'goldfill') {
        return this.goldTypes.filter(type => type.value !== 'usedgold')
      }

      return this.goldTypes
    }
  },

  methods: {
    emit(key, value) {
      this.$emit('change', { ...this.data, [key]: value })
    },

    submit() {
      this.$emit('submit')
    },

    async handleTypeChange(value) {
      if (value === 'goldfill') {
        const goldType = this.data.goldType

        const goldTypes = this.goldTypes.filter(
          type => type.value !== 'usedgold'
        )

        const hasGoldType = goldTypes.find(type => type.value === goldType)

        if (!hasGoldType) {
          await this.emit('goldType', null)
        }
      }

      await this.emit('type', value)
      this.submit()
    }
  },

  render() {
    return (
      <el-card>
        <h1 style={{ fontSize: '1.125rem', margin: '0 0 1rem' }}>ค้นหา</h1>
        <el-row type="flex" gutter={32} style={{ flexWrap: 'wrap' }}>
          <el-col md={12}>
            <SearchInput
              value={this.data.q}
              placeholder="ID,ผู้โอน,ผู้ส่ง"
              onInput={value => {
                this.emit('q', value)
              }}
              onSubmit={this.submit}
            />
          </el-col>
          <el-col
            md={12}
            style={{
              marginTop: ['sm', 'md'].includes(this.$mq) ? '0.5rem' : undefined
            }}
          >
            <el-row type="flex" gutter={16} style={{ flexWrap: 'wrap' }}>
              <el-col sm={8}>
                <el-select
                  value={this.data.type}
                  class={this.$style.typeSelect}
                  onChange={this.handleTypeChange}
                >
                  {this.types.map((item, index) => (
                    <el-option
                      key={index}
                      label={item.label}
                      value={item.value}
                    />
                  ))}
                </el-select>
              </el-col>
              <el-col
                sm={8}
                style={{ marginTop: this.$mq === 'sm' ? '0.5rem' : undefined }}
              >
                <el-select
                  value={this.data.status}
                  class={this.$style.typeSelect}
                  onChange={value => {
                    this.emit('status', value)
                    this.submit()
                  }}
                >
                  {this.statuses.map((item, index) => (
                    <el-option
                      key={index}
                      label={item.label}
                      value={item.value}
                    />
                  ))}
                </el-select>
              </el-col>
              <el-col
                sm={8}
                style={{ marginTop: this.$mq === 'sm' ? '0.5rem' : undefined }}
              >
                <el-select
                  value={this.data.goldType}
                  class={this.$style.typeSelect}
                  onChange={value => {
                    this.emit('goldType', value)
                    this.submit()
                  }}
                >
                  {this.filteredGoldTypes.map((item, index) => (
                    <el-option
                      key={index}
                      label={item.label}
                      value={item.value}
                    />
                  ))}
                </el-select>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-form inline style={{ marginTop: '1rem' }}>
          <el-form-item label="ช่วงเวลา">
            <el-date-picker
              value={this.data.period}
              type="daterange"
              startPlaceholder="Start Date"
              endPlaceholder="End Date"
              onInput={value => {
                this.emit('period', value)
                this.submit()
              }}
            />
          </el-form-item>
        </el-form>
      </el-card>
    )
  }
}
</script>

<style lang="scss" module>
.typeSelect {
  width: 100%;

  :global(.el-input__inner) {
    height: 3.5rem;
    line-height: 3.5rem;
  }
}
</style>
